import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/summer-vacation-2022/index.vue')
const Rank = () => import('../activity/summer-vacation-2022/Rank.vue')

export const index: RouteConfig = {
  path: '/summer-vacation-2022-sport-festival',
  name: 'summerVacation2022SportFestival',
  component: Index,
  meta: {
    title: '体智云2022夏季线上体育节',
  },
}

export const rank: RouteConfig = {
  path: '/summer-vacation-2022-sport-festival-rank',
  name: 'summerVacation2022SportFestivalRank',
  component: Rank,
  props: (v) => ({ type: +v.query.type || 0 }),
  meta: {
    title: '体智云2022夏季线上体育节',
  },
}

export default [index, rank]
